import { render, staticRenderFns } from "./CommodityUnloadOverrides.vue?vue&type=template&id=b0a1ef40"
import script from "./CommodityUnloadOverrides.vue?vue&type=script&lang=ts"
export * from "./CommodityUnloadOverrides.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports